import App from './components/App'
import { titles } from './config/constants'

export default function setContents(p = {}) {
    const { wapp } = p

    function getTitle({ wapp, res, title }) {
        const config = wapp.getTargetObject().config
        const { siteName = 'VLM' } = config
        const { statusCode, statusMessage, errorMessage } = res.wappResponse
        if (statusCode === 404) {
            title = statusMessage || titles.notFound
        }
        if (statusCode === 500) {
            title = errorMessage || statusMessage || titles.serverError
        }
        return title + ' | ' + siteName
    }

    wapp.contents.add({
        home: {
            render: App,
            description: titles.home,
            renderType: 'react',
            title: function(p) {
                return getTitle({ ...p, title: titles.home })
            }
        }
    })

    wapp.router.replace([
        { path: '/', contentName: 'home' }
    ])
}
